import React, { useEffect, useState } from 'react';
import AddItemCategoryModal  from '../../components/Configs/AddItemCategoryModal';
import EditItemCategoryModal  from '../../components/Configs/EditItemCategoryModal';
import { Row, Col, Button, Table, Badge } from 'react-bootstrap';
import { getCategories } from '../../services/Configs/ItemCategoriesService'; 
  

function ItemCategories(){ 
    const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
    const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
    const [reload, setReload] = useState(false);
    const [selectedItemCategoryId, setSelectedItemCategoryId] = useState(0);
    const [categories, setCategories] = useState([]);
    const handleAddCategory = () => {
        setShowAddCategoryModal(true);
    }
    const handleOpenEditModal = (id) => {
        setSelectedItemCategoryId(id);
        setShowEditCategoryModal(true);
    }

    useEffect(() => {
        getCategories().then(list => {
            setCategories(list);
        })
    },[reload])
    return (
        <>
        <Row>
            <Col xl={3}>
                <Button variant='info' onClick={handleAddCategory} >Agregar</Button>
            </Col>
        </Row>
        <Row>
            <Col xl={12}>
                <Table className='mb-5 mt-3' striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th className='text-center'>
                                Opciones
                            </th>
                            <th className='text-center'>
                                Nombre
                            </th>
                            <th className='text-center'>
                                Estatus
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    { 
                        categories.length == 0 ? (
                            <Row >
                                <Col xl={12} >
                                    <h4>No hay categorías</h4>
                                </Col>
                            </Row>
                        ) :
                        categories.map((item, index) => (
                            
                            <tr key={index} >
                                <td className='text-center'>
                                    <Button variant='secondary' onClick={() => {handleOpenEditModal(item.id)}} >...</Button>
                                </td>
                                <td className='text-center'>
                                    {item.name}
                                </td>
                                <td className='text-center'>
                                {item.isActive ?   <Badge bg="success">Activa</Badge> : <Badge bg="danger">Inactiva</Badge>  }
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </Table>     
            </ Col>
        </Row>
        <AddItemCategoryModal
        show={showAddCategoryModal}
        handleClose={() => setShowAddCategoryModal(false)}
        handleReload={() => { setReload(!reload) }}
         />
        <EditItemCategoryModal
        categoryId={selectedItemCategoryId}
        show={showEditCategoryModal}
        handleClose={() => setShowEditCategoryModal(false)}
        handleReload={() => { setReload(!reload) }}
         />

        
         </>
    )
}
export default ItemCategories